import { createContext, useContext } from 'react';
import type { ChatRuntime, UseChatRuntime } from './types';
import { useMockRuntime } from './mockRuntime';

export const ChatRuntimeContext = createContext<UseChatRuntime>(useMockRuntime);

/**
 * Resolves the active `ChatRuntime` by reading the `UseChatRuntime` hook out
 * of context and invoking it. Per Decision 2 (ADR-0001), the runtime is a
 * hook — not a plain object — so consumers always call the resolved hook on
 * each render rather than reaching for a singleton.
 * @returns the live `ChatRuntime` for the current React subtree.
 */
export const useChatRuntime = (): ChatRuntime => {
  const useRuntime = useContext(ChatRuntimeContext);
  return useRuntime();
};
